export const useSingletonHandler = (handler) => {
  const isHandled = ref(false);

  const handle = async (...args) => {
    if (isHandled.value) {
      return;
    }

    isHandled.value = true;
    await handler(...args).finally(() => (isHandled.value = false));
  };

  return { isHandled, handle };
};
